/* MeLuna quiz: save results and personal guidance popup. */
(() => {
  'use strict';

  if (
    window.location.pathname.replace(/\/$/, '') !==
    '/pages/menstrual-cup-quiz'
  ) return;

  if (window.melunaQuizGuidanceInitialized) return;
  window.melunaQuizGuidanceInitialized = true;

  const DELAY_MS = 45000;
  const FORM_URL =
    'https://melunausa.wufoo.com/forms/x1xcf8sx1pom1g7/';

  let timer = null;
  let recommendationActive = false;
  let shownForResult = false;
  let cartAdded = false;
  let stopPositioning = null;

  function visible(element) {
    if (!element || !element.getClientRects().length) {
      return false;
    }

    for (
      let node = element;
      node && node.nodeType === 1;
      node = node.parentElement
    ) {
      if (node.hidden || node.classList.contains('hide')) {
        return false;
      }

      const style = window.getComputedStyle(node);

      if (
        style.display === 'none' ||
        style.visibility === 'hidden'
      ) {
        return false;
      }
    }

    return true;
  }

  function resultVisible() {
    const quiz = document.getElementById('quiz-container');
    const results = document.querySelector(
      '.quiz-result-info-about'
    );

    const product = Array.from(
      document.querySelectorAll('.featured-product-section')
    ).find(visible);

    return Boolean(
      quiz &&
      !visible(quiz) &&
      (visible(results) || product)
    );
  }

  function emailSection() {
    const container = Array.from(
      document.querySelectorAll(
        '.newsletter-wufoo-form-container'
      )
    ).find(visible);

    if (container) {
      return container.closest('.newsletter-container') ||
        container;
    }

    const section = document.querySelector(
      '[id$="__newsletter_MbCDgz"]'
    );

    return visible(section) ? section : null;
  }

  function closeOffer() {
    if (stopPositioning) {
      stopPositioning();
    }

    stopPositioning = null;

    document.getElementById(
      'meluna-quiz-guidance-offer'
    )?.remove();
  }

  function cancelTimer() {
    if (timer !== null) {
      window.clearTimeout(timer);
    }

    timer = null;
  }

  function addStyles() {
    if (
      document.getElementById('meluna-quiz-guidance-style')
    ) return;

    const style = document.createElement('style');
    style.id = 'meluna-quiz-guidance-style';

    style.textContent = `
      #meluna-quiz-guidance-offer {
        position: fixed;
        inset: auto;
        z-index: 10000;
        width: 350px;
        min-width: 0;
        max-width: none;
        height: auto;
        min-height: 0;
        margin: 0;
        padding: 20px 18px 17px;
        box-sizing: border-box;
        transform: none;
        translate: none;
        background: #F6F2F8;
        color: #2A2543;
        border: 1px solid #e2d9eb;
        border-radius: 14px;
        box-shadow: 0 7px 28px rgba(32,18,43,.22);
        font-family: inherit;
        line-height: 1.45;
        text-align: left;
        overflow-y: auto;
        overflow-x: hidden;
        overscroll-behavior: contain;
      }

      #meluna-quiz-guidance-offer * {
        box-sizing: border-box;
      }

      #meluna-quiz-guidance-offer h2 {
        margin: 0 32px 10px 0;
        color: #2A2543;
        font-size: 18px;
        line-height: 1.3;
        font-weight: 600;
        text-transform: none;
        letter-spacing: normal;
      }

      #meluna-quiz-guidance-offer p {
        margin: 0 0 15px;
        color: #2A2543;
        font-size: 14px;
        line-height: 1.5;
      }

      #meluna-quiz-guidance-offer h2,
      #meluna-quiz-guidance-offer p {
        white-space: normal;
        overflow-wrap: anywhere;
      }

      #meluna-quiz-guidance-offer .meluna-save-results,
      #meluna-quiz-guidance-offer .meluna-personal-guidance {
        display: block;
        width: 100%;
        min-width: 0;
        max-width: 100%;
        min-height: 46px;
        height: auto;
        margin: 0;
        padding: 12px 16px;
        border: 2px solid;
        border-radius: 24px;
        appearance: none;
        background-image: none;
        font-family: inherit;
        font-size: 15px;
        font-weight: 700;
        line-height: 1.3;
        text-align: center;
        text-decoration: none;
        text-transform: none;
        letter-spacing: normal;
        white-space: normal;
        overflow-wrap: anywhere;
        cursor: pointer;
      }

      #meluna-quiz-guidance-offer .meluna-save-results {
        background: #9FCB3B;
        border-color: #9FCB3B;
        color: #2A2543;
      }

      #meluna-quiz-guidance-offer .meluna-save-results:hover {
        background: #8DB532;
        border-color: #8DB532;
        color: #2A2543;
      }

      #meluna-quiz-guidance-offer .meluna-personal-guidance {
        margin-top: 10px;
        background: #8D51A2;
        border-color: #8D51A2;
        color: #fff;
      }

      #meluna-quiz-guidance-offer .meluna-personal-guidance:hover {
        background: #713e84;
        border-color: #713e84;
        color: #fff;
      }

      #meluna-quiz-guidance-offer button:focus-visible,
      #meluna-quiz-guidance-offer a:focus-visible {
        outline: 2px solid #713e84;
        outline-offset: 3px;
      }

      #meluna-quiz-guidance-offer #meluna-quiz-guidance-close {
        position: absolute;
        right: 5px;
        top: 4px;
        display: block;
        width: 44px;
        min-width: 0;
        height: 44px;
        min-height: 0;
        margin: 0;
        padding: 5px;
        border: 0;
        border-radius: 0;
        background: transparent;
        color: #2A2543;
        font-family: inherit;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
      }

      @media (max-width: 600px) {
        #meluna-quiz-guidance-offer {
          padding: 17px 15px 15px;
        }

        #meluna-quiz-guidance-offer h2 {
          font-size: 17px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function trackPosition(offer) {
    let frame = null;
    const viewport = window.visualViewport;

    function position() {
      frame = null;

      if (!offer.isConnected) return;

      const width =
        viewport?.width ||
        document.documentElement.clientWidth;

      const height =
        viewport?.height ||
        window.innerHeight;

      const x = viewport?.offsetLeft || 0;
      const y = viewport?.offsetTop || 0;

      const mobile = window.matchMedia(
        '(max-width: 600px)'
      ).matches;

      const gap = mobile ? 12 : 16;

      const cardWidth = Math.min(
        350,
        Math.max(0, width - gap * 2)
      );

      const availableHeight = Math.max(
        0,
        height - gap * 2
      );

      offer.style.width = `${cardWidth}px`;
      offer.style.maxHeight = `${availableHeight}px`;

      const cardHeight =
        offer.getBoundingClientRect().height;

      const left = x + (
        mobile
          ? (width - cardWidth) / 2
          : width - cardWidth - gap
      );

      const top = y + Math.max(
        gap,
        mobile
          ? (height - cardHeight) / 2
          : height - cardHeight - gap
      );

      offer.style.left = `${left}px`;
      offer.style.top = `${top}px`;
      offer.style.visibility = 'visible';
    }

    function schedule() {
      if (frame === null) {
        frame = window.requestAnimationFrame(position);
      }
    }

    window.addEventListener('resize', schedule);
    viewport?.addEventListener('resize', schedule);
    viewport?.addEventListener('scroll', schedule);

    const resizeObserver = window.ResizeObserver
      ? new ResizeObserver(schedule)
      : null;

    resizeObserver?.observe(offer);
    position();

    return () => {
      if (frame !== null) {
        window.cancelAnimationFrame(frame);
      }

      window.removeEventListener('resize', schedule);
      viewport?.removeEventListener('resize', schedule);
      viewport?.removeEventListener('scroll', schedule);
      resizeObserver?.disconnect();
    };
  }

  function scrollToEmail() {
    const target = emailSection();

    if (!target) {
      const message = document.querySelector(
        '#meluna-quiz-guidance-offer p'
      );

      if (message) {
        message.textContent =
          'Look for “Save Your Result for Later” below your recommendation to email your results.';
      }

      return;
    }

    closeOffer();

    const header = document.querySelector(
      '#SiteHeader, .site-header'
    );

    const offset = Math.max(
      24,
      (header?.getBoundingClientRect().height || 0) + 20
    );

    const top = Math.max(
      0,
      target.getBoundingClientRect().top +
      window.scrollY -
      offset
    );

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    window.scrollTo({
      top,
      behavior: reducedMotion ? 'auto' : 'smooth'
    });
  }

  function showOffer() {
    if (
      shownForResult ||
      cartAdded ||
      !resultVisible()
    ) return;

    shownForResult = true;
    addStyles();
    closeOffer();

    const offer = document.createElement('aside');
    offer.id = 'meluna-quiz-guidance-offer';
    offer.style.visibility = 'hidden';

    offer.setAttribute(
      'aria-labelledby',
      'meluna-quiz-guidance-title'
    );

    offer.innerHTML = `
      <button
        id="meluna-quiz-guidance-close"
        type="button"
        aria-label="Dismiss offer"
      >&times;</button>

      <h2 id="meluna-quiz-guidance-title">
        Not ready to choose yet?
      </h2>

      <p>
        Save your quiz results by email, along with a coupon
        for your recommended cup. If you're unsure about
        your result, we can also help you choose.
      </p>

      <button
        type="button"
        class="meluna-save-results"
      >Save My Results</button>

      <a
        class="meluna-personal-guidance"
        href="${FORM_URL}"
        target="_blank"
        rel="noopener noreferrer"
      >Get a Personal Recommendation</a>
    `;

    offer.querySelector(
      '#meluna-quiz-guidance-close'
    ).addEventListener('click', closeOffer);

    offer.querySelector(
      '.meluna-save-results'
    ).addEventListener('click', scrollToEmail);

    document.body.appendChild(offer);
    stopPositioning = trackPosition(offer);
  }

  function checkRecommendation() {
    const nowActive = resultVisible();

    if (!nowActive) {
      if (recommendationActive) {
        recommendationActive = false;
        cancelTimer();
        closeOffer();
        shownForResult = false;
        cartAdded = false;
      }

      return;
    }

    if (recommendationActive) return;

    recommendationActive = true;

    if (shownForResult || cartAdded) return;

    timer = window.setTimeout(() => {
      timer = null;
      showOffer();
    }, DELAY_MS);
  }

  document.addEventListener(
    'ajaxProduct:added',
    (event) => {
      if (!recommendationActive) return;

      if (
        !event.target?.closest?.(
          '.featured-product-section'
        )
      ) return;

      cartAdded = true;
      cancelTimer();
      closeOffer();
    }
  );

  document.addEventListener('click', (event) => {
    if (
      !event.target.closest?.('[data-retake-quiz]')
    ) return;

    cancelTimer();
    closeOffer();
    recommendationActive = false;
    shownForResult = false;
    cartAdded = false;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOffer();
    }
  });

  function init() {
    const observer = new MutationObserver(
      checkRecommendation
    );

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    checkRecommendation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();